import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { upgradeTariffLabel } from '../../billing/paywallCopy'
import { isPivotModeEnabled } from '../../pivot/pivotMode'

type PaywallModalProps = {
  open: boolean
  title: string
  message: string
  upgradeLabel?: string
  showUpgradeAction?: boolean
  onDismiss: () => void
  onUpgrade?: () => void
}

export const PaywallModal = ({
  open,
  title,
  message,
  upgradeLabel,
  showUpgradeAction = true,
  onDismiss,
  onUpgrade,
}: PaywallModalProps) => {
  const navigate = useNavigate()
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) {
      return
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onDismiss()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    dialogRef.current?.focus()
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onDismiss])

  if (!open) {
    return null
  }

  const primaryLabel = upgradeLabel ?? upgradeTariffLabel
  const allowUpgrade = showUpgradeAction && !isPivotModeEnabled()

  const handleUpgrade = () => {
    onDismiss()
    if (onUpgrade) {
      onUpgrade()
      return
    }
    navigate('/payments')
  }

  return (
    <div className="market-paywall-overlay" role="presentation" onClick={onDismiss}>
      <div
        ref={dialogRef}
        className="market-paywall-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="market-paywall-title"
        aria-describedby="market-paywall-message"
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="market-paywall-title" className="market-paywall-modal__title">
          {title}
        </h2>
        <p id="market-paywall-message" className="market-paywall-modal__message">
          {message}
        </p>
        <div className="market-paywall-modal__actions">
          <button type="button" className="echat-btn echat-btn--ghost" onClick={onDismiss}>
            Позже
          </button>
          {allowUpgrade ? (
            <button type="button" className="echat-btn echat-btn--primary" onClick={handleUpgrade}>
              {primaryLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
